<div [ngClass]="getClass()">
  <form [formGroup]="usersForm">
    <form-factory [formGroup]="usersForm"
                  [model]="usersInput"
                  (onChange)="getUserInputValue($event)"></form-factory>
  </form>
</div>
